import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import {
  getSubscriptionPlansGQL,
  Query,
  PaymentGateway,
} from "@onmo/graphql/graphql";
import { find } from "lodash-es";

export const useSelectPlan = () => {
  const { data: plansData } = useQuery<Query>(getSubscriptionPlansGQL, {
    variables: { input: { productId: "aaa" } },
  });

  const getPlanGetway = useMemo(() => {
    if (!plansData) return;
    const plan = find(plansData?.subscriptionPlans?.items, {
      gateway: PaymentGateway.Juspay,
    });
    return plan;
  }, [plansData]);

  return getPlanGetway;
};
